module.exports = {"highlight-brands":{"discover":"Bekijk de collectie van :%brand% hier","explore":"Nu bekijken"}};